import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '@/lib/analytics';
import { updateIntercom } from '@/lib/intercom';

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    updateIntercom();
  }, [location.pathname, location.search]);

  return null;
}
